export const ToBuildingSmsTypes = {
  SHOW_SMS_BUILDING: "SHOW_SMS_BUILDING",
  SEND_SMS_BUILDING_PREVIEW: "SEND_SMS_BUILDING_PREVIEW",
  SEND_SMS_BUILDING: "SEND_SMS_BUILDING",
}